import React from "react";
import { motion } from "framer-motion";

import womanImg from "../../images/digital-readiness/dr1.png";

const HelloDR = () => {
  const gotoNext = () => {
    window.location.href = "/digital-readiness/DRStep1"; 
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-start bg-gradient-to-b from-blue-900 via-blue-700 to-blue-500 text-white relative overflow-hidden px-4">

      {/* TITLE */}
      <h1 className="text-2xl md:text-3xl font-extrabold text-yellow-300 mt-20 text-center drop-shadow-md">
        Now Let’s Find Out Your Digital Readiness
      </h1>

      {/* MAIN CONTENT */}
      <div className="relative mt-5 flex flex-col md:flex-row items-center md:items-start justify-center gap-4">

        {/* WOMAN IMAGE */}
        <img
          src={womanImg}
          alt="woman"
          className="w-[220px] md:w-[380px] drop-shadow-xl"
        />

        {/* TEXT WITHOUT BUBBLE */}
        <div
          className="
            text-left text-white
            text-base md:text-xl font-medium 
            leading-relaxed max-w-sm
            md:mt-6              /* naikkan agar sejajar dengan kepala */
            md:ml-[-5px]        /* geser ke kiri lebih dekat wanita */
          "
        >
          Choose the option that best matches<br />
          how you Digital Readiness.<br />
          You can pick more than one if several fit you.
        </div>
      </div>

      {/* BUTTON */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={gotoNext}
        className="mt-10 bg-yellow-300 text-blue-900 font-semibold px-10 py-3 rounded-full shadow-lg"
      >
        Let’s go →
      </motion.button>

      {/* FOOTER */}
      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default HelloDR;
